import { observable, action, makeObservable } from 'mobx'
import StatusModalStore from './StatusModalStore'
import TagsModalStore from './TagsModalStore'
import FieldsModalStore from './FieldsModalStore'

// Toolbar "Manage" modals: which one is open, plus a sub-store per modal.
class ManageModalStore {
  @observable type = null // 'status' | 'tags' | 'fields' | null

  status = new StatusModalStore()
  tags = new TagsModalStore()
  fields = new FieldsModalStore()

  constructor () {
    makeObservable(this)
  }

  // Each open starts the modal fresh, as it did when its state was component-local.
  @action open (type) {
    this.type = type
    this[type].open()
  }

  @action close () {
    this.type = null
  }
}

export default ManageModalStore
